import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { DialogTitle, IconButton, makeStyles, Typography } from '@material-ui/core'
import { Close } from "@material-ui/icons";
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    background: theme.palette.primary.main,
    color: "#fff",
    padding: '8px 16px'
  },
  dialogTitleSecondary: {
    background: theme.palette.secondary.main,
    color: "#fff",
    padding: '8px 16px'
  },
  dialogClose: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: '#fff'
  },
  actionButtons: {
    borderTop: '1px solid #ccc'
  }
}));

const ConfirmationDialog = (props) => {
  const classes = useStyles();
  const { message, title, handleResponse, open, confirmButtonProps, cancelButtonProps, responseData, isDelete=false } = props

  const handleClick = (val) => {
    handleResponse(val);
  }

  return (
    <Dialog open={open} onClose={() => handleResponse(false)} fullWidth>
      {title && <DialogTitle disableTypography id="confirmation-dialog-title" className={clsx({[classes.dialogTitle]:!isDelete,[classes.dialogTitleSecondary]:isDelete})} onClose={() => handleClick(false)}>
        <Typography variant='h4'>{title}</Typography>
        <IconButton className={classes.dialogClose} onClick={() => handleClick(false)}>
          <Close />
        </IconButton>
      </DialogTitle>}
      <DialogContent>
        {message}
      </DialogContent>
      <DialogActions className={classes.actionButtons}>
        <Button onClick={() => handleClick(false)} color="primary" {...cancelButtonProps} disabled={props.isLoading??false}>
        {props.txtCancel && props.txtCancel != null && props.txtCancel != undefined ? props.txtCancel : 'Cancel'}
        </Button>
        <Button onClick={() => handleClick(responseData ?? true)} color="primary" {...confirmButtonProps} disabled={props.isLoading??false}>
          {props.txtConfirm && props.txtConfirm != null && props.txtConfirm != undefined ? props.txtConfirm : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmationDialog;
